module.exports = __webpack_public_path__ + "img/classic_m3.9a39da5c.png";